'use client';
import { motion } from 'motion/react';
import Link from 'next/link';
import { useI18n, useDirection } from '@/i18n';
import { Button } from '@/components/ui/button';
import { ArrowRight, ArrowLeft } from 'lucide-react';

export function CTA() {
  const { t } = useI18n();
  const { isRTL } = useDirection();
  const ArrowIcon = isRTL ? ArrowLeft : ArrowRight;

  return (
    <section className="py-24 sm:py-32 bg-primary">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl sm:text-4xl font-display font-medium text-primary-foreground mb-4"
          >
            {t.cta.title}
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg text-primary-foreground/80 mb-8"
          >
            {t.cta.subtitle}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <Button
              asChild
              size="lg"
              className="bg-white text-primary hover:bg-white/90 h-12 px-6"
            >
              <Link href="/request-access">
                {t.cta.button}
                <ArrowIcon className="w-4 h-4 ms-2" />
              </Link>
            </Button>

            <p className="text-sm text-primary-foreground/60 mt-4">{t.cta.note}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
